import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useNavigate } from 'react-router';

const FlowCanvas = ({ onFlowChange }: any) => {
  const navigate = useNavigate();
  
  const handleFlowUpdate = (updatedFlow: any) => {
    if (onFlowChange) onFlowChange(updatedFlow);
  };

  return (
    <div>
      {/* Save Button with Label Inside */}
      <div style={{ position: 'fixed', bottom: '88px', right: '20px', textAlign: 'center', zIndex: 1000 }}>
        <Tooltip title="Save Changes" arrow>
          <IconButton
            style={{
              backgroundColor: '#128C7E',
              color: '#fff',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.3s ease',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px',
            }}
            onClick={(e: any) => {
              handleFlowUpdate(e);
            }}
          >
            <SaveIcon style={{ fontSize: '28px' }} />
            <Typography
              variant="caption"
              style={{
                marginTop: '4px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '10px'
              }}
            >
              Save
            </Typography>
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default FlowCanvas;
